import { render, staticRenderFns } from "./issuables_list_app.vue?vue&type=template&id=8a161578&"
import script from "./issuables_list_app.vue?vue&type=script&lang=js&"
export * from "./issuables_list_app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports